import type { TimeBlock } from '@/shared/domain'
import { formatTime } from '@/shared/infra/format'

function formatClock(value: string): string {
  const [hourPart, minutePart] = value.split(':')
  const hour = Number.parseInt(hourPart, 10)
  const minute = Number.parseInt(minutePart ?? '0', 10)
  if (Number.isNaN(hour) || Number.isNaN(minute)) return value
  return formatTime(new Date(2000, 0, 1, hour, minute))
}

export function formatTimeBlockLabel(block: Pick<TimeBlock, 'name' | 'startTime' | 'endTime'>): string {
  return `${block.name} · ${formatClock(block.startTime)} – ${formatClock(block.endTime)}`
}
